export default "__VITE_ASSET__CiIglpme__"